import apiRoutes from "./apiRoutes";
import { BaseCrudService } from "./baseCrudService";
import { OrganizationEventParticipationsResponse } from "../models/organizationEventParticipationsData";

/**
 * The organization event participations service
 */
export class OrganizationEventParticipationsService extends BaseCrudService {
  /**
   * Fetches the organization event participations data
   * @returns {Promise<OrganizationEventParticipationsData>}
   */
  async getEventParticipationsByOrganizationId(
    organizationId: string,
    sortedByEvent: boolean
  ) {
    const response = await this.getAll<OrganizationEventParticipationsResponse>(
      `${apiRoutes.organization_event_participations}/${organizationId}/get_organization_event_participations`,
      { sortedByEvent }
    );
    return response.data;
  }
}
